import React, { Component } from "react";
import "./tabs.css";
import PropType from "prop-types";

export default class Tab extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const { label, onClick } = this.props;
    onClick(label);
  }

  render() {
    let className = "tab-list-item";

    if (this.props.activeTab === this.props.label) {
      className += " tab-list-active";
    }

    return (
      <button
        className={className}
        onClick={this.onClick}
        onKeyPress={this.onClick}
        //role="tab"
      >
        <li>{this.props.label}</li>
      </button>
    );
  }
}

Tab.propTypes = {
  label: PropType.string.isRequired,
  onClick: PropType.func.isRequired,
  activeTab: PropType.string.isRequired,
};
